import { useState } from "react";
import { useInterval } from "./useInterval";

// Returns a value that changes on an interval, for work that depends on the
// current time rather than on data.
//
// The status auto-clear timeouts compare a timestamp against the wall clock, so
// the views that apply them have to re-evaluate as time passes. Order data alone
// cannot drive that: a bumped order is never updated again after it is bumped,
// and the periodic refetch returns an identical payload that Apollo dedupes, so
// without a tick the order stays in the current queue indefinitely.
export function useClockTick(intervalInMS?: number): number {
  const [tick, setTick] = useState(0);

  useInterval(() => setTick((previous) => previous + 1), intervalInMS);

  return tick;
}
